<template>
  <div>
    <Holidays v-if="windowResize.width > 1023" />
    <RedirectFromManager v-else />
  </div>
</template>

<script>
import Holidays from '../components/holidays/Holidays'
import { useWindowResize } from '@sichern/ui-elements'
import RedirectFromManager from './RedirectFromManager'

export default {
  components: {
    Holidays,
    RedirectFromManager
  },
  data() {
    return {
      windowResize: useWindowResize(this)
    }
  },
  created() {
    window.scrollTo(0, 0)
  }
}
</script>